export default __webpack_public_path__ + "media/images/logo-icon-2284b0ca.svg";